import { registerRoutingKey } from "Common/routingUtils";
export default {
    ERROR: registerRoutingKey("ERROR")
};
